import React, {Component} from 'react'
//import { withRouter } from 'react-router-dom';
//import * as routes from '../../../constants/routes';
import {connect} from 'react-redux'
import { compose } from 'recompose'
//import { withStyles } from '@material-ui/core/styles';
//import Button from '@material-ui/core/Button';
//import Typography from '@material-ui/core/Typography';
//import Grid from '@material-ui/core/Grid'
//import EventList from '../../../Container/Content/Events/EventList'
import AdminEventList from '../../../Container/Content/AdminEvents/AdminEventList'

//import Paper from '@material-ui/core/Paper'
import {doListenAdminEvents} from '../../../firebase/database/handleEvents'
import {doListenCanidates} from '../../../firebase/database/handleCanidates'
//import CounterBoard from '../../../Container/Content/CounterBoard/CounterBoard'
import Notification from '../../../Container/PopUps/Notification'
import InAppNav from '../../InAppNav/InAppNav'
import * as routes from '../../../constants/routes'
import DefaultPage from '../../../Container/Layout/DefaultPage'
import Loading from '../../../Container/Loading/Loading'
// ACTIVE
// Array sort Tool
import arraySort from 'array-sort'




const headline = 'Hilfebedarf vermitteln'

class AdminEvents extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          sortOption: 'name',
        };
    } 
    
async componentDidMount() {
    const { dispatchTogglePopUp } = this.props
    // Listen to Events
    doListenAdminEvents()
    // Listen to Canidates
    doListenCanidates()
    // hide popUp after 3000ms if in CanidateDetails set popUpVisable to true
    if(this.props.popUp===true){
        setTimeout(function(){ dispatchTogglePopUp(false)}, 4000);
    }
}

componentWillUnmount() {
   doListenAdminEvents(false)
   doListenCanidates(false)

}

getCounters = () => {
    //const eventCounter = this.props.events.length
    const {adminEvents} = this.props
    if(adminEvents===null) return null
        const eventsCounter = adminEvents.length
        const counterData = [
            {
                lable: 'Anzahl',
                value: eventsCounter,
            },
           
        ]
        return counterData  
}
    sortedData = () => {
        const sortedList = arraySort(this.props.adminEvents, 'data.date')
        return sortedList
    }

    notification = {
        headline: 'Der Helfer wurde vermittelt',
        content: 'Der Hilfebedarf wurde vermittelt. Der Helfer erhält eine Nachricht und muss die Vermittlung noch bestätigen.'
    }

    render() {
        const { canidateIds, adminEvents} = this.props 
       
        // <CounterBoard data={this.getCounters()} />
       
        return (
           
                <DefaultPage headline={{headlineText: headline }}>

                    <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}]}/>
                    {adminEvents===null
                        ? <Loading text='Hilfegesuche werden geladen....' />
                        : adminEvents.length!==0
                            ? <AdminEventList adminEvents={this.sortedData()} canidateIds={canidateIds}/>
                            : <span style={{fontWeight: 'bold', marginLeft: '16px'}}>Keine Hilfegesuche zum Anzeigen vorhanden</span>
                    }
                    {this.props.popUp
                    ? <Notification notification={this.notification}/>
                    : null
                }
                </DefaultPage>
            
        )
    }
}

const mapStateToProps = state =>({
    adminEvents: state.eventState.adminEvents,
    canidateIds: state.adminCanidateState.canidateIds,
          popUp: state.notificationState.inAppNotoficationVisable
})


const mapDispatchToProps = (dispatch) => ({
    dispatchTogglePopUp: (boolean)=>dispatch({type: 'IN_APP_NOTIFICATION', payload: boolean})
})

    
    export default compose(
            connect(mapStateToProps, mapDispatchToProps)
           
    )(AdminEvents)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEvents.js